// ============================================================
// types/promocion.types.ts — Promoción / Cierre de Año
// ============================================================

export type EstadoPromocion = 'PROMOVIDO' | 'REPITENTE' | 'EN_RECUPERACION' | 'TRASLADADO' | 'RETIRADO';

export interface CalcularPromocionPayload {
  gradoId: number;
  seccionId: number;
  anioEscolarId: number;
  usuarioId: number;
  forzar?: boolean;
}

export interface PromocionManualPayload {
  matriculaId: number;
  anioEscolarId: number;
  estado: EstadoPromocion;
  observacion?: string;
  usuarioId: number;
}

export interface EstadoPromocionResponse {
  idEstadoPromocion: number;
  matriculaId: number;
  estudianteId: number;
  estudianteNombres: string;
  estudianteApellidos: string;
  estudianteDni: string;
  anioEscolarId: number;
  anio: number;
  estado: EstadoPromocion;
  areasDesaprobadas: number;
  promedioAnual: number | null;
  observacion: string | null;
  fechaRegistro: string;
  puesto: number | null;
}

export const ESTADO_PROMO_LABEL: Record<EstadoPromocion, string> = {
  PROMOVIDO:       'Promovido',
  REPITENTE:       'Repite',
  EN_RECUPERACION: 'En Recuperación',
  TRASLADADO:      'Trasladado',
  RETIRADO:        'Retirado',
};

export const ESTADO_PROMO_COLOR: Record<EstadoPromocion, string> = {
  PROMOVIDO:       'bg-green-100 text-green-700',
  REPITENTE:       'bg-red-100 text-red-700',
  EN_RECUPERACION: 'bg-amber-100 text-amber-700',
  TRASLADADO:      'bg-blue-100 text-blue-700',
  RETIRADO:        'bg-slate-100 text-slate-600',
};
